<template>
	<div
		:class="{
			'active-player': true,
			open: !activePlayer || activePlayer.envelopes == 0,
		}"
	>
		<div v-if="activePlayer">
			<div :class="'list-item ' + (activePlayer.envelopes ? '' : 'completed')">
				<div class="info-section">
					<div class="name">
						{{ (activePlayer.name.split(',')[1] + ' ' + activePlayer.name.split(',')[0]).toLowerCase() }}
					</div>
					<div class="dealer">
						<span>{{ 'Cards Remaining: ' + activePlayer.envelopes }}</span
						>{{ activePlayer.store }}
					</div>
				</div>
				<div class="money">
					<span>$</span>
					<div>{{ formatPrice(moneyToShow) }}</div>
				</div>
			</div>
		</div>
		<div v-else>Waiting For PLayer to Play</div>
	</div>
</template>

<script>
	export default {
		name: 'LivePlayerActive',
		emits: ['update:goToWinners'],
		props: ['activePlayer', 'goToWinners', 'isGameDisplay'],
		data() {
			return {
				coin: new Audio('/static/audio/coin.mp3'),
				money: 0,
				moneyToShow: 0,
			};
		},
		computed: {},
		created() {
			this.moneyToShow = this.activePlayer.amount;
			this.$watch(
				() => this.activePlayer,
				newValue => {
					if (newValue) {
						if (newValue.amount == 0) {
							this.moneyToShow = 0;
						} else {
							this.money = newValue.amount - this.moneyToShow;
							this.animateMoney();
						}
						if (newValue.envelopes == 0) {
							setTimeout(() => {
								this.$emit('update:goToWinners', true);
							}, 2000);
						}
					}
				},
				{ deep: true },
			);
		},
		methods: {
			formatPrice(price) {
				return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			},
			animateMoney() {
				const moneyPerIteration = this.money < 10000 ? this.money / 50 : this.money / 75;
				let actualMoney = this.moneyToShow;
				const shouldBeMoney = parseInt(this.activePlayer.amount);
				if (this.isGameDisplay) {
					if (this.money < 10000) {
						this.coin.play().then(() => {
							setTimeout(() => {
								this.coin.pause();
								this.coin.currentTime = 0;
							}, 900);
						});
					} else {
						this.coin.play().then(() => {
							setTimeout(() => {
								this.coin.pause();
								this.coin.currentTime = 0;
							}, 1300);
						});
					}
				}

				const iteration = setInterval(() => {
					actualMoney += moneyPerIteration;
					this.moneyToShow = parseInt(actualMoney);
					if (actualMoney >= shouldBeMoney) {
						clearInterval(iteration);
						this.activePlayer.updating = false;
						this.$meetingHub.gameUpdateActivePlayerInfo(JSON.stringify(this.activePlayer));
					}
				}, 2);
			},
		},
	};
</script>
<style>
	.item {
		width: 100%;
		height: 30px;
		background-color: #f3f3f3;
		border: 1px solid #666;
		box-sizing: border-box;
	}

	/* 1. declare transition */
	.list-move,
	.list-enter-active,
	.list-leave-active {
		transition: all 3s cubic-bezier(0.55, 0, 0.1, 1);
	}

	/* 2. declare enter from and leave to state */
	.list-enter-from,
	.list-leave-to {
		opacity: 0;
		transform: scaleY(0.01) translate(30px, 0);
	}

	/* 3. ensure leaving items are taken out of layout flow so that moving
      animations can be calculated correctly. */
	.list-leave-active {
		position: absolute;
	}
</style>
